import React, { useContext } from 'react'
import { Card } from 'react-bootstrap'
import gql from 'graphql-tag'
import UserContext from '../contexts/UserContext'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const GET_CONNECTION_COUNT = gql`
  query GetItem($id: ID!) {
    item(id: $id) {
      id
      childItems {
        items {
          fileConnection {
            totalCount
          }
        }
        totalCount
      }
      fileConnection {
        totalCount
      }
    }
  }
`

export default function HomeCardMetrics() {
  const me = useContext(UserContext)
  const fetchVariables = (me) => {
    const myFolder = get(me, 'myFolder')

    if (!myFolder) return {}
    return {
      id: myFolder.id
    }
  }

  const { loading, data } = useQuery(
    GET_CONNECTION_COUNT,
    {
      variables: fetchVariables(me),
      fetchPolicy: 'cache-and-network',
    },
  )
  return (
    <>
      { data && data.item ?
        <Card bg="light">
          <Card.Header as="h4">
            <Link to={`/item/${me.myFolder.id}`}>
              My Folder
            </Link>&nbsp;
            { loading ? <FontAwesomeIcon icon={faSpinner} spin fixedWidth /> : '' }
          </Card.Header>
          <Card.Body>
            <Card.Title>
              <Link to={`item/${me.myFolder.id}/children`}>
                Children
              </Link>
            </Card.Title>
            <Card.Text>
              Total Children: {data.item.childItems.totalCount}
            </Card.Text>
            <Card.Title>
              <Link to={`item/${me.myFolder.id}/files`}>
                Files
              </Link>
            </Card.Title>
            <Card.Text>
             Total Files: {data.item.fileConnection.totalCount}
            </Card.Text>
          </Card.Body>
        </Card>
        : ''
      }
    </>
  )
}